import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawActivitiesIcon from "./ActivitiesIcon.svg.jsx";

const ActivitiesIcon = forwardRef((props, ref) => {
  return <Icon ref={ref} SvgComponent={RawActivitiesIcon} {...props} />;
});

export default ActivitiesIcon;
